import dynamic from 'next/dynamic';
import { NextPageWithLayout } from 'pages/page';
import Head from 'next/head';
import { CgSpinner } from 'react-icons/cg';
import { OthersAuthRedirection } from 'sharedui/functions/handleServerAuth';
import { useGetAllSearchQuery } from 'shared/src/hooks/util';
import { useEffect } from 'react';
import { saveAuthUserDetails } from 'shared/src/functions/authUtil';
import { useRouter } from 'next/router';
const AuthenticatedLayout: any = dynamic(
  () => import('sharedui/components/commons/AuthenticatedLayout'),
  {
    ssr: false,
  }
);
const Login: any = dynamic(
  () => import('../../features/auth/components/login/Login'),
  {
    loading: () => (
      <div className="absolute flex items-center justify-center w-screen h-screen mx-auto ">
        <CgSpinner className="text-4xl animate-spin text-accent-1" />
      </div>
    ),
  }
);

const Index: NextPageWithLayout = () => {
  const router = useRouter();
  const { queryValues } = useGetAllSearchQuery({});
  const userDetails = queryValues?.userData && JSON.parse(queryValues.userData);
  // This effects runs when user is coming from the web to dashboard
  //if they already have a token we will log them in automatically
  //Todo: this will be managed efficiently when we switch to multi-tenant app
  //But for now this hack should work!
  useEffect(() => {
    if (userDetails) {
      saveAuthUserDetails(userDetails);
      router.push('/dashboard');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <AuthenticatedLayout>
      <Login />
    </AuthenticatedLayout>
  );
};

Index.getLayout = function (page: any) {
  return (
    <>
      <Head>
        <meta
          name="viewport"
          content="initial-scale=1.0, width=device-width"
          key="title"
        />
        <title>Login</title>
      </Head>
      {page}
    </>
  );
};

export const getServerSideProps = (appContext: any) => {
  const {
    USER_ROLE_COOKIE,
    KYC_STATUS_COOKIE,
    IS_STRIPE_COOKIE,
    ACCOUNT_TYPE_COOKIE,
  } = appContext.req.cookies;

  const redirectDestination = OthersAuthRedirection({
    ACCOUNT_TYPE_COOKIE,
    IS_STRIPE_COOKIE,
    KYC_STATUS_COOKIE,
    USER_ROLE_COOKIE,
  });
  if (redirectDestination) {
    return {
      redirect: {
        destination: redirectDestination,
        permanent: false,
      },
    };
  }
  const props = {
    kycStatus: KYC_STATUS_COOKIE,
    userRole: USER_ROLE_COOKIE,
    isStripe: IS_STRIPE_COOKIE,
    accountType: ACCOUNT_TYPE_COOKIE,
  };
  // Check if userRole is undefined
  if (typeof USER_ROLE_COOKIE === 'undefined') {
    return {
      props: {},
    };
  }

  return {
    props,
  };
};

export default Index;
